import { AlertContextType } from '@/types/alerts'

// Demo function to add sample alerts for testing
export const addSampleAlerts = (alertContext: AlertContextType) => {
  // Add some sample alerts with different hierarchy levels
  alertContext.addAlert({
    message: 'New promotion campaign started - 15% increase in sales expected',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Overview',
    },
  })

  alertContext.addAlert({
    message: 'Inventory levels are running low for this item',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Overview',
    },
  })

  alertContext.addAlert({
    message: 'Sales performance exceeded expectations by 20%',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Sales',
    },
  })

  alertContext.addAlert({
    message: 'Profitability margin has increased by 8% this week',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Profitability',
    },
  })

  alertContext.addAlert({
    message: 'High discount usage detected - review pricing strategy',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Discounts',
    },
  })

  alertContext.addAlert({
    message: 'Frequently bought with croissant - consider bundle promotion',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Bought Together',
    },
  })

  alertContext.addAlert({
    message: 'Credit card payments increasing for this item',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Snow Peak',
      tab: 'Payment Type',
    },
  })

  // Add some alerts for other items for testing
  alertContext.addAlert({
    message: 'New seasonal variant performing well',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
      item: 'Ocean Breeze',
      tab: 'Overview',
    },
  })

  // Add category-level alerts for testing AccordionView
  alertContext.addAlert({
    message: 'Category performance trending upward this month',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Mocha',
    },
  })

  alertContext.addAlert({
    message: 'Latte category shows strong seasonal growth patterns',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Latte',
    },
  })

  alertContext.addAlert({
    message: 'Supply chain issues affecting category availability',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Mocha',
    },
  })

  alertContext.addAlert({
    message: 'New competitor product launched in this category',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Amped',
    },
  })

  alertContext.addAlert({
    message: 'Category sales exceeded monthly target',
    hierarchy: {
      clarityLens: 'Sales Lens',
      category: 'Classics',
    },
  })

  // Add Material Codes alerts for testing
  alertContext.addAlert({
    message: 'Price increase notification from supplier',
    hierarchy: {
      clarityLens: 'Spend Lens',
      category: 'Dairy',
      subCategory: 'Alternative Milk',
      item: 'Oat Milk',
      tab: 'Overview',
    },
  })

  // Add Material Codes item-level alerts
  alertContext.addAlert({
    message: 'Spend analysis shows cost optimization opportunity',
    hierarchy: {
      clarityLens: 'Spend Lens',
      category: 'Dairy',
      subCategory: 'Alternative Milk',
      item: 'Oat Milk',
      tab: 'Overview',
    },
  })

  alertContext.addAlert({
    message: 'Compliance issue detected in recent shipment',
    hierarchy: {
      clarityLens: 'Spend Lens',
      category: 'Dairy',
      subCategory: 'Alternative Milk',
      item: 'Oat Milk',
      tab: 'Spend',
    },
  })

  alertContext.addAlert({
    message: 'Price history shows unusual fluctuation',
    hierarchy: {
      clarityLens: 'Spend Lens',
      category: 'Dairy',
      subCategory: 'Alternative Milk',
      item: 'Oat Milk',
      tab: 'Price History',
    },
  })
}

// Helper function to simulate real-time alerts
export const simulateRealTimeAlert = (
  alertContext: AlertContextType,
  message: string
) => {
  alertContext.addAlert({
    message,
    hierarchy: {
      clarityLens: 'Real-time Monitoring',
      category: 'System Alerts',
      tab: 'Live Feed',
    },
  })
}
